export const GlobeIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='31.564'
      height='31.563'
      viewBox='0 0 31.564 31.563'
    >
      <g
        id='Group_1097'
        data-name='Group 1097'
        transform='translate(-4176.718 -3246.954)'
      >
        <g
          id='Group_13'
          data-name='Group 13'
          transform='translate(4176.718 3246.954)'
        >
          <g id='Group_12' data-name='Group 12'>
            <path
              id='Path_4'
              data-name='Path 4'
              d='M4192.453,3278.312a15.623,15.623,0,1,1,15.624-15.623A15.641,15.641,0,0,1,4192.453,3278.312Zm0-30.4a14.774,14.774,0,1,0,14.775,14.775A14.792,14.792,0,0,0,4192.453,3247.914Z'
              transform='translate(-4176.671 -3246.907)'
            />
            <path
              id='Path_5'
              data-name='Path 5'
              d='M4192.5,3278.518a15.782,15.782,0,1,1,15.782-15.782A15.8,15.8,0,0,1,4192.5,3278.518Zm0-31.246a15.464,15.464,0,1,0,15.464,15.464A15.482,15.482,0,0,0,4192.5,3247.271Zm0,30.4a14.933,14.933,0,1,1,14.934-14.933A14.95,14.95,0,0,1,4192.5,3277.668Zm0-29.549a14.616,14.616,0,1,0,14.615,14.617A14.634,14.634,0,0,0,4192.5,3248.119Z'
              transform='translate(-4176.718 -3246.954)'
            />
          </g>
        </g>
        <g
          id='Group_15'
          data-name='Group 15'
          transform='translate(4191.864 3247.184)'
        >
          <g id='Group_14' data-name='Group 14'>
            <path
              id='Path_6'
              data-name='Path 6'
              d='M4187.936,3278.088a.424.424,0,0,1-.071-.842c6.014-1.031,10.551-7.317,10.551-14.625,0-7.194-4.277-13.315-10.169-14.554a.424.424,0,1,1,.174-.829c6.283,1.321,10.842,7.791,10.842,15.383,0,7.714-4.838,14.361-11.256,15.461A.392.392,0,0,1,4187.936,3278.088Z'
              transform='translate(-4187.353 -3247.069)'
            />
            <path
              id='Path_7'
              data-name='Path 7'
              d='M4187.982,3278.294a.582.582,0,0,1-.475-.919.572.572,0,0,1,.377-.238c5.939-1.018,10.417-7.238,10.417-14.469,0-7.119-4.222-13.175-10.041-14.4a.583.583,0,0,1-.451-.69.585.585,0,0,1,.69-.451c6.356,1.337,10.969,7.872,10.969,15.54,0,7.791-4.9,14.506-11.389,15.619A.621.621,0,0,1,4187.982,3278.294Zm.4-30.859a.251.251,0,0,0-.143.043.263.263,0,0,0-.116.167.267.267,0,0,0,.206.314c5.965,1.253,10.294,7.439,10.294,14.709,0,7.384-4.593,13.739-10.684,14.782a.258.258,0,0,0-.171.108.267.267,0,0,0-.046.2.264.264,0,0,0,.306.215c6.342-1.085,11.125-7.666,11.125-15.3,0-7.519-4.507-13.922-10.716-15.228A.238.238,0,0,0,4188.38,3247.435Z'
              transform='translate(-4187.4 -3247.116)'
            />
          </g>
        </g>
        <g
          id='Group_17'
          data-name='Group 17'
          transform='translate(4181.063 3247.185)'
        >
          <g id='Group_16' data-name='Group 16'>
            <path
              id='Path_8'
              data-name='Path 8'
              d='M4191.172,3278.088a.419.419,0,0,1-.073-.005c-6.388-1.1-11.2-7.747-11.2-15.461,0-7.593,4.539-14.062,10.792-15.383a.424.424,0,1,1,.176.829c-5.864,1.239-10.12,7.36-10.12,14.554,0,7.308,4.514,13.594,10.5,14.625a.424.424,0,0,1-.072.842Z'
              transform='translate(-4179.735 -3247.07)'
            />
            <path
              id='Path_9'
              data-name='Path 9'
              d='M4191.22,3278.294a.521.521,0,0,1-.1-.008c-6.462-1.112-11.336-7.827-11.336-15.618,0-7.668,4.594-14.2,10.92-15.54a.583.583,0,1,1,.24,1.141c-5.79,1.224-9.994,7.278-9.994,14.4,0,7.231,4.458,13.451,10.37,14.469a.583.583,0,0,1-.1,1.157Zm-.4-30.859a.266.266,0,0,0-.057.006c-6.18,1.306-10.666,7.71-10.666,15.228,0,7.638,4.76,14.218,11.073,15.3a.249.249,0,0,0,.307-.215.27.27,0,0,0-.044-.2.259.259,0,0,0-.172-.108c-6.062-1.043-10.634-7.4-10.634-14.782,0-7.27,4.309-13.456,10.247-14.709a.265.265,0,0,0-.055-.524Z'
              transform='translate(-4179.782 -3247.117)'
            />
          </g>
        </g>
        <g
          id='Group_19'
          data-name='Group 19'
          transform='translate(4181.294 3251.64)'
        >
          <g id='Group_18' data-name='Group 18'>
            <path
              id='Path_10'
              data-name='Path 10'
              d='M4191.1,3255.646a15.525,15.525,0,0,1-11.048-4.575l.6-.6a14.775,14.775,0,0,0,20.994-.1l.6.592A15.5,15.5,0,0,1,4191.1,3255.646Z'
              transform='translate(-4179.898 -3250.212)'
            />
            <path
              id='Path_11'
              data-name='Path 11'
              d='M4191.151,3255.854a15.682,15.682,0,0,1-11.16-4.623.159.159,0,0,1,0-.226l.6-.6a.16.16,0,0,1,.226,0,14.615,14.615,0,0,0,20.769-.1.16.16,0,0,1,.226,0l.6.594a.154.154,0,0,1,.047.111.152.152,0,0,1-.045.113A15.66,15.66,0,0,1,4191.151,3255.854Zm-10.823-4.736a15.467,15.467,0,0,0,21.75-.1l-.378-.372a14.937,14.937,0,0,1-21,.1Z'
              transform='translate(-4179.945 -3250.259)'
            />
          </g>
        </g>
        <g
          id='Group_21'
          data-name='Group 21'
          transform='translate(4181.185 3268.237)'
        >
          <g id='Group_20' data-name='Group 20'>
            <path
              id='Path_12'
              data-name='Path 12'
              d='M4180.585,3267.357l-.606-.594a15.623,15.623,0,0,1,22.2-.111l-.6.6a14.774,14.774,0,0,0-21,.1Z'
              transform='translate(-4179.821 -3261.918)'
            />
            <path
              id='Path_13'
              data-name='Path 13'
              d='M4180.632,3267.563a.155.155,0,0,1-.111-.045l-.605-.595a.16.16,0,0,1,0-.225,15.786,15.786,0,0,1,22.431-.11.161.161,0,0,1,0,.225l-.6.6a.159.159,0,0,1-.225,0,14.618,14.618,0,0,0-20.773.1.15.15,0,0,1-.11.049Zm-.38-.754.378.37a14.935,14.935,0,0,1,21-.1l.375-.376a15.464,15.464,0,0,0-21.752.109Z'
              transform='translate(-4179.868 -3261.965)'
            />
          </g>
        </g>
        <g
          id='Group_22'
          data-name='Group 22'
          transform='translate(4177.142 3262.152)'
        >
          <rect
            id='Rectangle_6'
            data-name='Rectangle 6'
            width='30.398'
            height='0.848'
            transform='translate(0.159 0.159)'
          />
          <path
            id='Path_14'
            data-name='Path 14'
            d='M4207.574,3258.84h-30.4a.159.159,0,0,1-.159-.159v-.848a.16.16,0,0,1,.159-.16h30.4a.161.161,0,0,1,.159.16v.848A.16.16,0,0,1,4207.574,3258.84Zm-30.239-.318h30.079v-.53h-30.079Z'
            transform='translate(-4177.017 -3257.673)'
          />
        </g>
        <g
          id='Group_23'
          data-name='Group 23'
          transform='translate(4191.917 3246.954)'
        >
          <path
            id='Path_15'
            data-name='Path 15'
            d='M4187.974,3278.312a.425.425,0,0,1-.424-.425v-30.4a.424.424,0,1,1,.848,0v30.4A.424.424,0,0,1,4187.974,3278.312Z'
            transform='translate(-4187.391 -3246.907)'
          />
          <path
            id='Path_16'
            data-name='Path 16'
            d='M4188.021,3278.518a.584.584,0,0,1-.583-.584v-30.4a.583.583,0,0,1,1.166,0v30.4A.583.583,0,0,1,4188.021,3278.518Zm0-31.246a.266.266,0,0,0-.265.265v30.4a.265.265,0,0,0,.53,0v-30.4A.266.266,0,0,0,4188.021,3247.271Z'
            transform='translate(-4187.438 -3246.954)'
          />
        </g>
      </g>
    </svg>
  );
};

